
<component :is="tag" v-if="message">
  <slot :message="message">
    <help-tooltip mode="danger" :text="message"></help-tooltip>
  </slot>
</component>
